<div class="portal-page-container container-fluid pr-lgcol-lg-0">
  <div class="row">
    <app-side-menu [isCollapsed]="toggle" (toggleCollapse)="toggleMenu($event)"></app-side-menu>
    <div class="col portal-page">
      <app-header-bar (toggleMenu)="toggleMenu($event)"></app-header-bar>

      <div class="product-signup-container mt-3">
        <div class="card-top-bar">
          <button class="btn-back-top" (click)="goBack()">
            <i class="fas fa-arrow-left"></i>
            <span>{{ translate.currentLang === 'en' ? 'Back' : 'পিছনে' }}</span>
          </button>
        </div>
        <div class="container">
          <!-- Step Navigation -->
          <div class="step-navigation-section">
            <app-step-navigation [steps]="steps" [currentStepIndex]="currentStepIndex" [showStepNumbers]="true"
              [showStepDescriptions]="true" [allowBackNavigation]="true" [allowSkipSteps]="true"
              [backButtonText]="'Previous'" [nextButtonText]="'Continue'" [finishButtonText]="'Submit Application'"
              [isLastStep]="currentStepIndex === steps.length - 1" [loading]="loading" [disableNext]="disableNext"
              [showValidationErrors]="showValidationErrors" (stepChange)="onStepChange($event)"
              (stepClick)="onStepClick($event)" (onBack)="onBack()" (onNext)="onNext()" (onFinish)="onFinish()">
            </app-step-navigation>
          </div>

          <div class="loader" *ngIf="formInLoading"></div>
          <form #form="ngForm" [formGroup]="productForm" novalidate *ngIf="productForm">
            <div class="step-content-area">
              <app-step-container [hidden]="currentStep !== 1" [title]="steps[0].title"
                [stepDescription]="steps[0].description" [stepId]="steps[0].id" [stepNumber]="1"
                [isActive]="getStepStatus(0).isActive" [isCompleted]="getStepStatus(0).isCompleted">
                <div class="form-content">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-lg-auto">
                        <app-radio-button label="BO Type" name="boType" [options]="boTypeOptions"
                          [formControl]="productForm.get('boType')" required="true"
                          layout="horizontal"></app-radio-button>
                      </div>
                      <div class="col-lg-3" [hidden]="productForm.get('boType').value !== 'linkBo'">
                        <app-form-input label="BO ID" pattern="^[0-9]+$" [formControl]="productForm.get('boId')"
                          [required]="productForm.get('boType').value === 'linkBo'"></app-form-input>
                      </div>
                    </div>
                  </div>

                  <h2 (click)="collapseSection('individual')" class="cursor-pointer">
                    First A/C Holder
                    <i class="float-end"
                      [ngClass]="isCollapseSection['individual'] ? 'fa fa-plus-circle' : 'fa fa-minus-circle'"></i>
                  </h2>
                  <div class="form-group">
                    <ng-container *ngIf="!isCollapseSection['individual']">
                      <div class="row">
                        <div class="col-lg-3">
                          <app-radio-button label="Type of Account" name="accountHolderType" layout="horizontal"
                            [options]="[{ id: 'individual', text: 'Individual', description: '' }]"
                            [formControl]="productForm.get('accountHolderType')" required="true"
                            layout="horizontal"></app-radio-button>
                        </div>
                        <div class="col-lg">
                          <div class="form-group">
                            <app-radio-button layout="horizontal" name="gender" label="Gender" [options]="[
                                { id: 'male', text: 'Male' },
                                { id: 'female', text: 'Female' }
                              ]" [formControl]="productForm.get('gender')" required="true"></app-radio-button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-3">
                          <app-drop-down label="Courtesy Title" [options]="courtesyTitleOptions"
                            [formControl]="productForm.get('courtesyTitle')"
                            placeholder="Select courtesy title"></app-drop-down>
                        </div>
                        <div class="col-lg-3">
                          <div class="form-group">
                            <app-form-input label="First Name" [formControl]="productForm.get('firstName')"
                              required="true"></app-form-input>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="form-group">
                            <app-form-input label="Last Name" [formControl]="productForm.get('lastName')"
                              required="true"></app-form-input>
                          </div>
                        </div>

                        <div class="col-lg-3">
                          <app-form-input label="Occupation" [formControl]="productForm.get('occupation')"
                            [required]="true"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-datepicker [maxDate]="todayDate" label="Date of Birth"
                            [formControl]="productForm.get('dateOfBirth')" required="true"></app-datepicker>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Father's Name" [formControl]="productForm.get('fathersName')"
                            required="true"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Mother's Name" [formControl]="productForm.get('mothersName')"
                            required="true"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-textarea rows="1" label="Address Line1" [formControl]="productForm.get('addressLine1')"
                            required="true"></app-textarea>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-lg-6">
                            <app-textarea rows="2" label="Address Line2"
                              [formControl]="productForm.get('addressLine2')"></app-textarea>
                          </div>
                          <div class="col-lg-6">
                            <app-textarea label="Address Line3" rows="2"
                              [formControl]="productForm.get('addressLine3')"></app-textarea>
                          </div>

                          <div class="col-lg-3">
                            <app-form-input label="City" [formControl]="productForm.get('city')"
                              required="true"></app-form-input>
                          </div>
                          <div class="col-lg-3">
                            <app-form-input label="District"
                              [formControl]="productForm.get('district')"></app-form-input>
                          </div>
                          <div class="col-lg-3">
                            <app-form-input label="Post Code" [formControl]="productForm.get('postCode')"
                              required="true"></app-form-input>
                          </div>
                          <div class="col-lg-3">
                            <app-drop-down label="Country" [options]="countryOptions"
                              [formControl]="productForm.get('country')" placeholder="Select country"
                              required="true"></app-drop-down>
                          </div>
                          <div class="col-lg-3">
                            <div class="form-group">
                              <app-form-input label="Mobile" pattern="^[0-9]+$"
                                [formControl]="productForm.get('mobile')" required="true"></app-form-input>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="form-group">
                              <app-form-input label="Email" emailVerificationOn="true" [disabled]="true"
                                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                                [formControl]="productForm.get('email')" [required]="true"
                                [emailVerified]="productForm.get('emailVerified').value"></app-form-input>
                              <app-verify-email [hidden]="productForm.get('emailVerified').value"
                                [email]="productForm.get('email').value"
                                (verifyEmail)="onVerifyEmail($event)"></app-verify-email>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="form-group">
                              <app-form-input label="Telephone" pattern="^[0-9]+$"
                                [formControl]="productForm.get('telephone')"></app-form-input>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="form-group">
                              <app-form-input label="Fax" pattern="^[0-9]+$"
                                [formControl]="productForm.get('fax')"></app-form-input>
                            </div>
                          </div>

                          <div class="col-lg-3">
                            <div class="form-group">
                              <app-form-input label="Nationality" [formControl]="productForm.get('nationality')"
                                required="true"></app-form-input>
                            </div>
                          </div>

                          <div class="col-lg-3">
                            <div class="form-group">
                              <app-form-input label="National ID" [formControl]="productForm.get('nationalId')"
                                required="true"></app-form-input>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="form-group">
                              <app-form-input label="TIN" [formControl]="productForm.get('tin')"></app-form-input>
                            </div>
                          </div>
                          <div class="col-lg-3">
                            <div class="form-group">
                              <app-drop-down label="Broker Branch" [options]="brokerBranchOptions"
                                [formControl]="productForm.get('brockerBranch')" placeholder="Select broker branch"
                                required="true"></app-drop-down>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group">
                              <app-radio-button name="residentialStatus" layout="horizontal" label="Residential Status"
                                [options]="residentialStatusOptions"
                                [formControl]="productForm.get('residentialStatus')" required="true"></app-radio-button>
                            </div>
                          </div>

                          <div class="col-12">
                            <div class="form-group">
                              <app-radio-button name="officerOrSponsor"
                                label="Whether the applicant is Officer or Sponsor/Director of any Broker/Dealer/Exchange/Depository/Clearing & Settlement company/Listed Company"
                                [options]="[
                                  { id: 'yes', text: 'Yes' },
                                  { id: 'no', text: 'No' }
                                ]" [formControl]="productForm.get('officerOrSponsor')" required="true"
                                layout="horizontal"></app-radio-button>
                            </div>
                          </div>
                          <div class="col" *ngIf="productForm.get('officerOrSponsor').value === 'yes'">
                            <div class="form-group">
                              <app-form-input label="Company Name"
                                [formControl]="productForm.get('officerCompanyName')"></app-form-input>
                            </div>
                          </div>
                          <div class="col" *ngIf="productForm.get('officerOrSponsor').value === 'yes'">
                            <div class="form-group">
                              <app-form-input label="Designation"
                                [formControl]="productForm.get('officerDesignation')"></app-form-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="form-content" *ngIf="productForm.get('accountHolderType').value === 'joint'">
                  <h2 (click)="collapseSection('joint')" class="cursor-pointer">
                    Joint Applicant(2nd Account Holder)
                    <i class="float-end"
                      [ngClass]="isCollapseSection['joint'] ? 'fa fa-plus-circle' : 'fa fa-minus-circle'"></i>
                  </h2>
                  <ng-container *ngIf="!isCollapseSection['joint']">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-lg">
                          <app-drop-down label="Courtesy Title" [options]="courtesyTitleOptions"
                            [formControl]="productForm.get('jointCourtesyTitle')"
                            placeholder="Select courtesy title"></app-drop-down>
                        </div>
                        <div class="col-lg">
                          <div class="form-group">
                            <app-form-input label="First Name" [formControl]="productForm.get('jointFirstName')"
                              [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                          </div>
                        </div>
                        <div class="col-lg">
                          <div class="form-group">
                            <app-form-input label="Last Name" [formControl]="productForm.get('jointLastName')"
                              [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-6">
                          <app-form-input label="Occupation" [formControl]="productForm.get('jointOccupation')"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                        </div>
                        <div class="col-lg-6">
                          <app-datepicker [maxDate]="todayDate" label="Date of Birth"
                            [formControl]="productForm.get('jointDateOfBirth')"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-datepicker>
                        </div>
                        <div class="col-lg-6">
                          <app-form-input label="Father's Name" [formControl]="productForm.get('jointFathersName')"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                        </div>
                        <div class="col-lg-6">
                          <app-form-input label="Mother's Name" [formControl]="productForm.get('jointMothersName')"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-6">
                          <app-textarea label="Address Line1" [formControl]="productForm.get('jointAddressLine1')"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-textarea>
                        </div>
                        <div class="col-lg-6">
                          <app-textarea [rows]="2" label="Address Line2"
                            [formControl]="productForm.get('jointAddressLine2')"></app-textarea>
                        </div>
                        <div class="col-lg-12">
                          <app-textarea [rows]="2" label="Address Line3"
                            [formControl]="productForm.get('addressLine3')"></app-textarea>
                        </div>

                        <div class="col-lg-3">
                          <app-form-input label="City" [formControl]="productForm.get('jointCity')"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="District" [formControl]="productForm.get('jointDistrict')"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Post Code" [formControl]="productForm.get('jointPostCode')"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-drop-down label="Country" [options]="countryOptions"
                            [formControl]="productForm.get('jointCountry')" placeholder="Select jointCountry"
                            [required]="productForm.get('accountHolderType').value === 'joint'"></app-drop-down>
                        </div>
                        <div class="col-lg-3">
                          <div class="form-group">
                            <app-form-input label="Mobile" [formControl]="productForm.get('jointMobile')"
                              [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="form-group">
                            <app-form-input label="Email Address" [formControl]="productForm.get('jointEmail')"
                              [required]="productForm.get('accountHolderType').value === 'joint'"></app-form-input>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="form-group">
                            <app-form-input label="Telephone"
                              [formControl]="productForm.get('jointTelephone')"></app-form-input>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="form-group">
                            <app-form-input label="Fax" [formControl]="productForm.get('jointFax')"></app-form-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </app-step-container>
              <!-- Step 2 -->
              <app-step-container [hidden]="currentStep !== 2" [title]="steps[1].title"
                [stepDescription]="steps[1].description" [stepId]="steps[1].id" [stepNumber]="2"
                [isActive]="getStepStatus(1).isActive" [isCompleted]="getStepStatus(1).isCompleted">
                <div class="form-content">
                  <div class="loader" [hidden]="!bankInProcessing"></div>
                  <div class="row" [hidden]="bankInProcessing">
                    <div class="col-lg-3">
                      <app-drop-down label="Bank Name" [options]="bankOptions"
                        [formControl]="productForm.get('bankCode')" placeholder="Select Bank"
                        required="true"></app-drop-down>
                    </div>
                    <div class="col-lg-3">
                      <app-drop-down [loading]="branchInProcessing" label="Branch Name" [options]="branchOptions"
                        [formControl]="productForm.get('branchName')" placeholder="Select Branch"
                        required="true"></app-drop-down>
                      <span class="text-muted small" [hidden]="!productForm.get('bankRoutingNumber').value">Routing
                        Number: {{ productForm.get('bankRoutingNumber').value }}</span>
                    </div>
                    <!-- <div class="col-lg-3">
                      <app-form-input
                        label="Bank Routing Number"
                        [formControl]="productForm.get('bankRoutingNumber')"
                        [readonly]="true"
                        placeholder="Auto-populated from branch"
                      ></app-form-input>
                    </div> -->
                    <div class="col-lg-3">
                      <app-form-input label="Bank District"
                        [formControl]="productForm.get('bankDistrict')"></app-form-input>
                      <span class="text-muted small" [hidden]="!productForm.get('bankDistrictCode').value">District
                        Code: {{ productForm.get('bankDistrictCode').value }}</span>
                    </div>
                    <div class="col-lg-3">
                      <app-form-input maxlength="13" pattern="^[0-9]{13}$" label="Bank A/C Number"
                        [formControl]="productForm.get('accountNumber')" required="true"></app-form-input>
                      <p class="text-warning small">** Bank A/C must be exactly 13 digits.</p>
                    </div>
                  </div>
                </div>
              </app-step-container>

              <!-- Step 3 -->
              <app-step-container [hidden]="currentStep !== 3" [title]="steps[2].title"
                [stepDescription]="steps[2].description" [stepId]="steps[2].id" [stepNumber]="3"
                [isActive]="getStepStatus(2).isActive" [isCompleted]="getStepStatus(2).isCompleted">
                <h2 (click)="collapseSection('nominee1')" class="cursor-pointer">
                  Nominee 1
                  <i class="float-end"
                    [ngClass]="isCollapseSection['nominee1'] ? 'fa fa-plus-circle' : 'fa fa-minus-circle'"></i>
                </h2>
                <ng-container *ngIf="!isCollapseSection['nominee1']">
                  <div class="form-content">
                    <div class="row">
                      <div class="col-lg-3">
                        <app-drop-down label="Courtesy Title" [options]="courtesyTitleOptions"
                          [formControl]="productForm.get('nominee1CourtesyTitle')"
                          placeholder="Select courtesy title"></app-drop-down>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="First Name" [formControl]="productForm.get('nominee1FirstName')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Last Name" [formControl]="productForm.get('nominee1LastName')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Relation" [formControl]="productForm.get('nominee1Relation')"
                          required="true"></app-form-input>
                      </div>

                      <div class="col-lg-3">
                        <app-form-input label="Percentage" [formControl]="productForm.get('nominee1Percentage')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-9">
                        <app-radio-button name="nominee1ResidentialStatus" label="Residential Status"
                          [options]="residentialStatusOptions"
                          [formControl]="productForm.get('nominee1ResidentialStatus')" required="true"
                          layout="horizontal"></app-radio-button>
                      </div>
                      <div class="col-lg-3">
                        <app-datepicker [maxDate]="todayDate" label="Date of Birth"
                          [formControl]="productForm.get('nominee1DateOfBirth')" [required]="true"></app-datepicker>
                      </div>
                      <div class="col-lg-3">
                        <div class="form-group">
                          <app-form-input label="Nationality" [formControl]="productForm.get('nominee1Nationality')"
                            required="true"></app-form-input>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="NID" [formControl]="productForm.get('nominee1NId')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Address Line1" rows="2"
                          [formControl]="productForm.get('nominee1AddressLine1')" required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input rows="2" label="Address Line2"
                          [formControl]="productForm.get('nominee1AddressLine2')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input rows="2" label="Address Line3"
                          [formControl]="productForm.get('nominee1AddressLine3')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="City" [formControl]="productForm.get('nominee1City')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Post Code" [formControl]="productForm.get('nominee1PostCode')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Division" [formControl]="productForm.get('nominee1Division')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Country" [formControl]="productForm.get('nominee1Country')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Email" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                          [formControl]="productForm.get('nominee1Email')" required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Mobile" [formControl]="productForm.get('nominee1Mobile')"
                          required="true"></app-form-input>
                      </div>


                      <div class="col-lg-3">
                        <app-form-input label="Father's Name" [formControl]="productForm.get('nominee1FathersName')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Mother's Name" [formControl]="productForm.get('nominee1MothersName')"
                          required="true"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Profession" [formControl]="productForm.get('nominee1Profession')"
                          required="true"></app-form-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <app-switch id="nominee1Guardian"
                      label="Do you want to add Nominee 1 Guardian (If Nominee is A Minor) ?"
                      [formControl]="productForm.get('nominee1Guardian')"></app-switch>
                  </div>
                  <div class="form-content" [ngClass]="{ 'd-none': !productForm?.get('nominee1Guardian')?.value }">
                    <h2>Nominee 1 Guardian (If Nominee is A Minor)</h2>

                    <div class="row">
                      <div class="col-lg-3">
                        <app-drop-down label="Courtesy Title" [options]="courtesyTitleOptions"
                          [formControl]="productForm.get('nominee1GuardianCourtesyTitle')"
                          placeholder="Select courtesy title"></app-drop-down>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="First Name" [formControl]="productForm.get('nominee1GuardianFirstName')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Last Name" [formControl]="productForm.get('nominee1GuardianLastName')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Relation" [formControl]="productForm.get('nominee1GuardianRelation')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>

                      <div class="col-lg-3">
                        <app-form-input label="Percentage" [formControl]="productForm.get('nominee1GuardianPercentage')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-9">
                        <app-radio-button name="nominee1GuardianResidentialStatus" label="Residential Status"
                          [options]="residentialStatusOptions"
                          [formControl]="productForm.get('nominee1GuardianResidentialStatus')"
                          [required]="productForm?.get('nominee1Guardian')?.value"
                          layout="horizontal"></app-radio-button>
                      </div>
                      <div class="col-lg-3">
                        <app-datepicker [maxDate]="todayDate" label="Date of Birth"
                          [formControl]="productForm.get('nominee1GuardianDateOfBirth')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-datepicker>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Nationality"
                          [formControl]="productForm.get('nominee1GuardianNationality')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="NID" pattern="^[0-9]+$"
                          [formControl]="productForm.get('nominee1GuardianNId')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Address Line1"
                          [formControl]="productForm.get('nominee1GuardianAddressLine1')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Address Line2"
                          [formControl]="productForm.get('nominee1GuardianAddressLine2')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Address Line3"
                          [formControl]="productForm.get('nominee1GuardianAddressLine3')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="City" [formControl]="productForm.get('nominee1GuardianCity')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Post Code" [formControl]="productForm.get('nominee1GuardianPostCode')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Division" [formControl]="productForm.get('nominee1GuardianDivision')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Country" [formControl]="productForm.get('nominee1GuardianCountry')"
                          [required]="productForm?.get('nominee1Guardian')?.value"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Email" [formControl]="productForm.get('nominee1GuardianEmail')"
                          [required]="productForm?.get('nominee1Guardian')?.value"
                          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Mobile" [formControl]="productForm.get('nominee1GuardianMobile')"
                          [required]="productForm?.get('nominee1Guardian')?.value" pattern="^[0-9]+$"></app-form-input>
                      </div>

                    </div>
                  </div>
                </ng-container>
                <h2 (click)="collapseSection('nominee2')" class="cursor-pointer">
                  Nominee 2
                  <i class="float-end"
                    [ngClass]="isCollapseSection['nominee2'] ? 'fa fa-plus-circle' : 'fa fa-minus-circle'"></i>
                </h2>
                <ng-container *ngIf="!isCollapseSection['nominee2']">
                  <div class="form-content">
                    <div class="row">
                      <div class="col-lg-3">
                        <app-drop-down label="Courtesy Title" [options]="courtesyTitleOptions"
                          [formControl]="productForm.get('nominee2CourtesyTitle')"
                          placeholder="Select courtesy title"></app-drop-down>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="First Name"
                          [formControl]="productForm.get('nominee2FirstName')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Last Name"
                          [formControl]="productForm.get('nominee2LastName')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Relation"
                          [formControl]="productForm.get('nominee2Relation')"></app-form-input>
                      </div>

                      <div class="col-lg-3">
                        <app-form-input label="Percentage"
                          [formControl]="productForm.get('nominee2Percentage')"></app-form-input>
                      </div>
                      <div class="col-lg-9">
                        <app-radio-button name="nominee2ResidentialStatus" label="Residential Status"
                          [options]="residentialStatusOptions"
                          [formControl]="productForm.get('nominee2ResidentialStatus')"
                          layout="horizontal"></app-radio-button>
                      </div>
                      <div class="col-lg-3">
                        <app-datepicker [maxDate]="todayDate" label="Date of Birth"
                          [formControl]="productForm.get('nominee2DateOfBirth')"></app-datepicker>
                      </div>
                      <div class="col-lg-3">
                        <div class="form-group">
                          <app-form-input label="Nationality"
                            [formControl]="productForm.get('nominee2Nationality')"></app-form-input>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="NID" [formControl]="productForm.get('nominee2NId')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Address Line1"
                          [formControl]="productForm.get('nominee2AddressLine1')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Address Line2"
                          [formControl]="productForm.get('nominee2AddressLine2')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Address Line3"
                          [formControl]="productForm.get('nominee2AddressLine3')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="City" [formControl]="productForm.get('nominee2City')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Post Code"
                          [formControl]="productForm.get('nominee2PostCode')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Division"
                          [formControl]="productForm.get('nominee2Division')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Country"
                          [formControl]="productForm.get('nominee2Country')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Email" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                          [formControl]="productForm.get('nominee2Email')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Mobile" pattern="^[0-9]+$"
                          [formControl]="productForm.get('nominee2Mobile')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Father's Name"
                          [required]="productForm?.get('nominee2FirstName')?.value ? true : false"
                          [formControl]="productForm.get('nominee2FathersName')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Mother's Name"
                          [required]="productForm?.get('nominee2FirstName')?.value ? true : false"
                          [formControl]="productForm.get('nominee2MothersName')"></app-form-input>
                      </div>
                      <div class="col-lg-3">
                        <app-form-input label="Profession"
                          [required]="productForm?.get('nominee2FirstName')?.value ? true : false"
                          [formControl]="productForm.get('nominee2Profession')"></app-form-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <app-switch id="nominee2Guardian"
                      label="Do you want to add Nominee 2 Guardian (If Nominee is A Minor) ?"
                      [formControl]="productForm.get('nominee2Guardian')"></app-switch>
                  </div>
                  <div class="form-content" *ngIf="productForm?.get('nominee2Guardian')?.value">
                    <h2 (click)="collapseSection('nominee2Guardian')" class="cursor-pointer">
                      Nominee 2 Guardian (If Nominee is A Minor)
                      <i class="float-end"
                        [ngClass]="isCollapseSection['nominee2Guardian'] ? 'fa fa-plus-circle' : 'fa fa-minus-circle'"></i>
                    </h2>
                    <ng-container *ngIf="!isCollapseSection['nominee2Guardian']">
                      <div class="row">
                        <div class="col-lg-3">
                          <app-drop-down label="Courtesy Title" [options]="courtesyTitleOptions"
                            [formControl]="productForm.get('nominee2GuardianCourtesyTitle')"
                            placeholder="Select courtesy title"></app-drop-down>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="First Name"
                            [formControl]="productForm.get('nominee2GuardianFirstName')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Last Name"
                            [formControl]="productForm.get('nominee2GuardianLastName')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Relation"
                            [formControl]="productForm.get('nominee2GuardianRelation')"></app-form-input>
                        </div>

                        <div class="col-lg-3">
                          <app-form-input label="Percentage"
                            [formControl]="productForm.get('nominee2GuardianPercentage')"></app-form-input>
                        </div>
                        <div class="col-lg-9">
                          <app-radio-button name="nominee2ResidentialStatus" label="Residential Status"
                            [options]="residentialStatusOptions"
                            [formControl]="productForm.get('nominee2GuardianResidentialStatus')"
                            layout="horizontal"></app-radio-button>
                        </div>
                        <div class="col-lg-3">
                          <app-datepicker [maxDate]="todayDate" label="Date of Birth"
                            [formControl]="productForm.get('nominee2GuardianDateOfBirth')"></app-datepicker>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Nationality"
                            [formControl]="productForm.get('nominee2GuardianNationality')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="NID"
                            [formControl]="productForm.get('nominee2GuardianNId')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Address Line1"
                            [formControl]="productForm.get('nominee2GuardianAddressLine1')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Address Line2"
                            [formControl]="productForm.get('nominee2GuardianAddressLine2')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Address Line3"
                            [formControl]="productForm.get('nominee2GuardianAddressLine3')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="City"
                            [formControl]="productForm.get('nominee2GuardianCity')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Post Code"
                            [formControl]="productForm.get('nominee2GuardianPostCode')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Division"
                            [formControl]="productForm.get('nominee2GuardianDivision')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Country"
                            [formControl]="productForm.get('nominee2GuardianCountry')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Email" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                            [formControl]="productForm.get('nominee2GuardianEmail')"></app-form-input>
                        </div>
                        <div class="col-lg-3">
                          <app-form-input label="Mobile" pattern="^[0-9]+$"
                            [formControl]="productForm.get('nominee2GuardianMobile')"></app-form-input>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </app-step-container>

              <!-- Step 4: Documents -->
              <app-step-container [hidden]="currentStep !== 4" [title]="steps[3].title"
                [stepDescription]="steps[3].description" [stepId]="steps[3].id" [stepNumber]="4"
                [isActive]="getStepStatus(3).isActive" [isCompleted]="getStepStatus(3).isCompleted">
                <div class="documents-content">
                  <h2 (click)="collapseSection('documents')" class="cursor-pointer">
                    Please upload the following documents to complete your application.
                    <i class="float-end"
                      [ngClass]="isCollapseSection['documents'] ? 'fa fa-plus-circle' : 'fa fa-minus-circle'"></i>
                  </h2>
                  <ng-container *ngIf="!isCollapseSection['documents']">
                    <div class="document-upload-section">
                      <div class="row">
                        <div class="col-lg-6">
                          <app-document-upload documentType="BO" [productSignupId]="productId"
                            label="Document of Link BO" [formControl]="productForm.get('boAttachment')"
                            [required]="productForm.get('boType').value === 'linkBo'"></app-document-upload>
                        </div>
                        <div class="col-lg-6">
                          <app-document-upload documentType="SELFIE" allowedTypes="image/jpg,image/jpeg,image/png"
                            [productSignupId]="productId" label="First Applicant (1st Holder) Photo"
                            [formControl]="productForm.get('firstApplicantPhotoAttachment')"
                            required="true"></app-document-upload>
                        </div>

                        <div class="col-lg-6">
                          <app-document-upload documentType="NID_PP_DRIVING_BOTH_SIDE" [productSignupId]="productId"
                            label="First Applicant (1st Holder) – NID or Passport (Front & Rear Sides)"
                            [formControl]="productForm.get('nidPassportDrivingBothSideAttachment')"
                            required="true"></app-document-upload>
                        </div>

                        <div class="col-lg-6">
                          <app-document-upload documentType="SIGNATURE" [productSignupId]="productId"
                            label="Signature of First Applicant"
                            [formControl]="productForm.get('firstApplicantSignatureAttachment')"
                            required="true"></app-document-upload>
                        </div>
                        <div class="col-lg-6">
                          <app-document-upload documentType="TIN" [productSignupId]="productId"
                            label="TIN Certificate of First Applicant (1st Holder)"
                            [formControl]="productForm.get('firstApplicantTINAttachment')"
                            required="true"></app-document-upload>
                        </div>
                        <div class="col-lg-6">
                          <app-document-upload documentType="BANK_STATEMENT" [productSignupId]="productId"
                            label="Bank Statement/Certificate/Cheque Copy"
                            [formControl]="productForm.get('firstApplicantBankStatementAttachment')"
                            required="true"></app-document-upload>
                        </div>

                        <div class="col-lg-6">
                          <app-document-upload documentType="NOMINEE_PHOTO"
                            allowedTypes="image/jpg,image/jpeg,image/png" [productSignupId]="productId"
                            label="Nominee 1 Photo" [formControl]="productForm.get('nominee1ApplicantPhotoAttachment')"
                            required="true"></app-document-upload>
                        </div>
                        <div class="col-lg-6">
                          <app-document-upload documentType="NOMINEE_NID_PP_DRIVING_BOTH_SIDE"
                            [productSignupId]="productId" label="Nominee 1 NID or Passport (Front & Rear Sides)"
                            [formControl]="productForm.get('nominee1ApplicantNIDAttachment')"
                            required="true"></app-document-upload>
                        </div>
                        <div class="col-lg-6">
                          <app-document-upload documentType="NOMINEE_SIGNATURE" [productSignupId]="productId"
                            label="Signature of Nominee 1"
                            [formControl]="productForm.get('nominee1ApplicantSignatureAttachment')"
                            required="true"></app-document-upload>
                        </div>
                        <div class="col-lg-6">
                          <app-document-upload documentType="NOMINEE_2_PHOTO" [productSignupId]="productId"
                            label="Nominee 2 Photo" [formControl]="productForm.get('nominee2ApplicantPhotoAttachment')"
                            [required]="productForm?.get('nominee2FirstName')?.value ? true : false"></app-document-upload>
                        </div>
                        <div class="col-lg-6">
                          <app-document-upload documentType="NOMINEE_2_SIGNATURE" [productSignupId]="productId"
                            label="Signature of Nominee 2"
                            [formControl]="productForm.get('nominee2ApplicantSignatureAttachment')"
                            [required]="productForm?.get('nominee2FirstName')?.value ? true : false"></app-document-upload>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </app-step-container>

              <app-step-container [hidden]="currentStep !== 5" [title]="steps[4].title"
                [stepDescription]="steps[4].description" [stepId]="steps[4].id" [stepNumber]="5"
                [isActive]="getStepStatus(4).isActive" [isCompleted]="getStepStatus(4).isCompleted">
                <div class="confirmation-content">
                  <div class="row">
                    <div class="col-auto">
                      <app-checkbox required="true" label="I agree to the terms and conditions"
                        [formControl]="productForm.get('termsAndConditions')"></app-checkbox>
                    </div>
                    <div class="col pt-2 text-primary cursor-pointer"
                      (click)="viewTermsAndConditions = !viewTermsAndConditions">
                      [{{ viewTermsAndConditions ? 'Collapse' : 'View' }}]
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12" [hidden]="!viewTermsAndConditions">
                      <app-prd-terms-and-condition></app-prd-terms-and-condition>
                    </div>
                  </div>
                </div>
              </app-step-container>
            </div>

            <!-- Navigation Buttons -->
            <div class="step-navigation-buttons pb-4">
              <button type="button" class="btn btn-secondary" [disabled]="currentStep === 1"
                (click)="previousStep()">Back</button>
              <button type="button" class="btn btn-primary" *ngIf="currentStep !== totalSteps"
                [attr.disabled]="loading ? 'disabled' : null" (click)="onNext()">
                Next
              </button>
              <button [attr.disabled]="submitInProgress ? 'disabled' : null" type="button" class="btn btn-primary"
                *ngIf="currentStep === totalSteps" (click)="onFinish()">
                <span class="ws-loading ws-loading-progress" *ngIf="submitInProgress"></span> {{ submitInProgress ? '' :
                'Complete' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>